module.exports = __webpack_public_path__ + "img/default-btn-en.66748b3b.png";